import type { ReactElement } from "react";
import { CmtsReferenceAdminContainer } from "../../core/containers/domain/masterdataRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsReferenceAdminContainer runtime={props.runtime} />;
}

export default Component;
